import { createContext, useState } from "react";

export const NationalityContext = createContext({});

export const Provider = (props) => {
    const { children } = props;

    const [nationalities, setNationalities] = useState([]);

    // Make the context object:
    const nationalityContext = {
        nationalities,
        setNationalities,
    };

    // pass the value in provider and return
    return <NationalityContext.Provider value={nationalityContext}>{children}</NationalityContext.Provider>;
};

export const { Consumer } = NationalityContext;
